import { Field } from 'components/Wizards/Field/Field'
import { PrimaryMarketLocationsProps } from './Types'
import { AddLocationPill } from './AddLocationPill'
import { useState } from 'react'
import { Chip } from 'components/Chip/Chip'
import Styles from './PrimaryMarketLocations.module.scss'
import { ConditionalWrapper } from 'common/ConditionalWrapper/ConditionalWrapper'
import cx from 'classnames'

const PrimaryMarketLocations = ({
  locations,
  onUpdate,
  label = 'Primary Market Locations',
  subLabel,
  description,
  fieldProps,
  headingLevel = 3,
  labelColor,
  size = 'md',
  className,
}: PrimaryMarketLocationsProps) => {
  const [adding, setAdding] = useState(false)

  const handleRemove = (location: string) => {
    const newSet = new Set([...locations])
    newSet.delete(location)
    onUpdate(newSet)
  }

  const handleAdd = (location: string) => {
    setAdding(false)
    onUpdate(new Set([...locations, location]))
  }

  return (
    <Field
      label={label}
      description={description}
      headingLevel={headingLevel}
      data-testid="primary-market-locations"
      labelColor={labelColor}
      {...fieldProps}
    >
      <ConditionalWrapper
        condition={!!subLabel}
        wrapper={(children) => (
          <Field
            label="Primary Market Locations"
            labelType="label"
            data-testid="primary-market-locations"
            labelColor={labelColor}
          >
            {children}
          </Field>
        )}
      >
        <div className={cx(Styles.container, className)}>
          {Array.from(locations).map((location) => (
            <Chip
              key={location}
              variant="flat"
              isSelected
              deletable
              selectable={false}
              onPress={() => handleRemove(location)}
              size={size}
            >
              {location}
            </Chip>
          ))}
          <AddLocationPill
            onSelect={handleAdd}
            onActiveChange={(active) => setAdding(active)}
            isActive={adding}
            locations={locations}
            size={size}
          />
        </div>
      </ConditionalWrapper>
    </Field>
  )
}

export { PrimaryMarketLocations }
